import bosSuccess from '../../assets/common/bos-success.svg';
import { AppContent } from '../AppContent';

const thankYou: AppContent['thankYou'] = {
  thankYouContent: [
    {
      serviceName: 'Business Internet Banking',
      thankYou: 'Thank you',
      nextSteps: 'Next steps',
      gotYourRequest:
        'We’ve got your request to register for Business Internet Banking.',
      finalChecks:
        'We just need to do some final checks to verify your details. Once those are complete, we’ll email you to let you know what happens next.',
      imageSrc: bosSuccess,
      imageAltText: 'Thank you',
    },
  ],
};

export default thankYou;
